export interface RegisterForm {
  email: string;
  password?: string;
  password_confirm?: string;
  first_name?: string;
  last_name?: string;
  facebook_code?: string;
  facebook_redirect_uri?: string;
}
